import SearchResultItem from './SearchResultItem';
import { useState, useEffect, useRef } from "react";

const SearchResult = ({
    showResult,
    locations,
    onSearchResultItemEnter,
    onSearchResultItemLeave,
    onSearchResultItemClicked,
    searchString,
    categories,
    selectedLocation,
    onSearchResultReset
}) => {

    const [isHiding, setIsHiding] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const itemsRef = useRef(null);
    const lastScrollY = useRef(window.scrollY);

    const handleMouseEnter = (location, index) => {
        if (onSearchResultItemEnter) {
            onSearchResultItemEnter(location, index);
        }
    };

    const handleMouseLeave = (location, index) => {
        if (onSearchResultItemLeave) {
            onSearchResultItemLeave(location, index);
        }
    };

    const handleClick = (location, index) => {
        if (onSearchResultItemClicked) {
            onSearchResultItemClicked(location, index);
        }
    };

    const filteredBy = () => {
        const activeCategories = categories
            .filter(cat => cat.active)
            .map(cat => cat.label);

        return activeCategories.length > 0
            ? '(gefiltert nach ' + activeCategories.join(', ') + ')'
            : '';
    };

    const onClickReset = () => {
        setCollapsed(false);
        setIsHiding(true);
    }

    const onClickExpand = () => {
        setCollapsed(false);
    }

    const handleAnimationEnd = () => {
        if (isHiding && onSearchResultReset) {
            onSearchResultReset();
            setIsHiding(false);
        }
    };

    // 👇 Auto-collapse when user scrolls up and list is not visible
    useEffect(() => {
        if (showResult && !selectedLocation) {
            const observer = new IntersectionObserver(([entry]) => {
                const isVisible = entry.isIntersecting;
                const scrollY = window.scrollY;
                const scrollUp = scrollY < lastScrollY.current;
                lastScrollY.current = scrollY;
                if (!isVisible && scrollUp) {
                    setCollapsed(true);
                }
            }, {
                threshold: 0.1
            });

            const target = itemsRef.current;
            if (target) {
                observer.observe(target);
            }

            return () => {
                if (target) {
                    observer.unobserve(target);
                }
                observer.disconnect();
            };
        }
    }, [showResult, selectedLocation]);

    useEffect(() => {
        setCollapsed(false);
    }, [locations]);

    return (
        <div ref={itemsRef} className={`search-result-container ${collapsed ? 'collapsed' : ''} ${isHiding ? 'fade-out' : ''}`} onAnimationEnd={handleAnimationEnd}>
        {showResult ? (
            <>
                <div className='search-result-notice px-4 py-3'>Hier sind die <b>{locations.length}</b> nächsten E3/DC-Fachpartner in der Nähe von {searchString} {filteredBy()}</div>
                <div className={`search-result-items-container`}>
                    {locations.map((location, index) => (
                    <SearchResultItem
                        key={index}
                        location={location}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        onClick={handleClick}
                        index={index}
                        isSelected={selectedLocation && selectedLocation.id === location.id}
                    />
                    ))}
                </div>
                { collapsed ? (
                    <div className='search-result-reset d-flex justify-content-center' onClick={onClickExpand}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                        </svg>
                    </div>
                ) :
                    <div className='search-result-reset d-flex justify-content-center' onClick={onClickReset}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-chevron-up" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                        </svg>
                    </div>
                }
            </>
        ) : (
            <div className='search-result-notice px-4 py-3'>Bitte geben Sie einen Ort ein, um E3/DC-Fachpartner in Ihrer Nähe zu finden.</div>
        )}
        </div>
    );
};

export default SearchResult;
